import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { enhancedLocalStorage } from '@halo/utils';
import type { LanguageListKeys } from '@/configs/i18n';
import { defaultLanguage, languageMap } from '@/configs/i18n';

export const i18nPromise = i18n.use(initReactI18next).init({
  fallbackLng: defaultLanguage,
  resources: languageMap,
  lng: getUserLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export function getUserLanguage(): LanguageListKeys {
  return enhancedLocalStorage.getItem('language') || defaultLanguage;
}

export function setUserLanguage(language: LanguageListKeys | undefined) {
  if (language) {
    enhancedLocalStorage.setItem('language', language);
  } else {
    enhancedLocalStorage.removeItem('language');
  }
}

export { i18n };
